import styled from 'styled-components';
import theme from 'lib/theme';

const Wrap = styled.div`
  position: absolute;
  padding: 10px;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.4);
  border: solid 1px rgba(0, 0, 0, 0);
  background-color: #fff;
  border-radius: 4px;
  font-size: var(--fs-base);
  white-space: normal;
  line-height: 20px;
  text-align: left;
  color: ${theme.color.gray};
  z-index: ${(props) => {
    return props.theme.zIndex.floatPopup;
  }};

  &:before {
    content: '';
    position: absolute;
    //box-shadow: -2px 2px 0 2px #fff, 0 0 10px rgba(0, 0, 0, 0.4);
    height: 10px;
    width: 10px;
    background: #fff;
  }

  ._dark & {
    background-color: ${theme.clientColor.popupBgColor};
    color: #fff;
    &:before {
      background-color: ${theme.clientColor.popupBgColor};
    }
  }

  &.arrow-up {
    top: 100%;
    left: 50%;
    transform: translate(-50%, 10px);

    &:before {
      left: 50%;
      top: -6px;
      transform: translateX(-50%) rotate(-45deg);
    }
  }

  &.arrow-left {
    left: 100%;
    top: 50%;
    transform: translate(10px, -50%);

    &:before {
      top: 50%;
      left: -6px;
      transform: translateY(-50%) rotate(225deg);
    }
  }

  &.arrow-right {
    right: 100%;
    top: 50%;
    transform: translate(-10px, -50%);

    &:before {
      top: 50%;
      right: -6px;
      transform: translateY(-50%) rotate(45deg);
    }
  }

  &.arrow-down {
    bottom: 100%;
    left: 50%;
    transform: translate(-50%, -10px);

    &:before {
      left: 50%;
      bottom: -6px;
      transform: translateX(-50%) rotate(-45deg);
    }
  }
`;

const TipBox = (props) => {
  const {
    type, // up right left down
    className = '',
    ...rest
  } = props;

  return (
    <Wrap {...rest} className={`_tip-box ${className} arrow-${type}`}></Wrap>
  );
};

export default TipBox;
